if (document.querySelector(".section_impact")) {
    // Use GSAP matchMedia for responsive conditions
    gsap.matchMedia().add("(min-width: 768px)", () => {
      const contentItems = document.querySelectorAll(".impact_content-wrap");
  
      const animationValues = {
        scale: 1,
        blur: "3px",
        moveX: "1.5rem",
        moveY: "5rem",
      };
  
      const inAnimation = {
        opacity: 1,
        y: 0,
        x: 0,
        scale: 1,
        filter: 'blur(0px)',
        duration: 1,
        ease: 'power2.out'
      };
  
      const outAnimation = {
        opacity: 0,
        y: animationValues.moveY,
        x: animationValues.moveX,
        scale: animationValues.scale,
        filter: `blur(${animationValues.blur})`,
        duration: 1,
        ease: 'power2.in'
      };
  
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: '.section_impact',
          start: 'top top',
          end: "bottom bottom",
          markers: false,
          scrub: true,
        }
      });
  
      contentItems.forEach((item, index) => {
        if (index === 0) {
          gsap.set(item, {
            opacity: 1,
            scale: 1,
            y: 0,
            x: 0,
            filter: 'blur(0px)',
            rotationX: 0,
            rotationY: 0,
          });
  
          tl.to(item, outAnimation, "<0.3");
  
        } else if (index === contentItems.length - 1) {
          tl.fromTo(
            item,
            {
              opacity: 0,
              y: `-${animationValues.moveY}`,
              x: `-${animationValues.moveX}`,
              filter: `blur(${animationValues.blur})`,
            },
            inAnimation
          );
        } else {
          tl.fromTo(
              item,
              {
                opacity: 0,
                y: `-${animationValues.moveY}`,
                x: `-${animationValues.moveX}`,
                scale: 1,
                filter: `blur(${animationValues.blur})`,
              },
              inAnimation
            )
            .to(item, outAnimation);
        }
      });
  
      // Second part of the animation
      const visualItems = document.querySelectorAll(".impact_visual");
  
      const animationValuesVisual = {
        mask: "clip-path: inset(0% 0% 0% 0%)",
        maskOut: "clip-path: inset(100% 0% 0% 0%)",
      };
  
      const inAnimationVisual = {
        clipPath: "inset(0% 0% 0% 0%)",
        duration: 0.5,
        ease: 'power1.out',
      };
  
      const outAnimationVisual = {
        clipPath: "inset(100% 0% 0% 0%)",
        duration: 0.5,
        ease: 'power1.in',
      };
  
      const visualTl = gsap.timeline({
        scrollTrigger: {
          trigger: '.section_impact',
          start: 'top top',
          end: "bottom bottom",
          markers: false,
          scrub: true,
        }
      });
  
      visualItems.forEach((item, index) => {
        const backgroundImage = item.querySelector(".impact_visual img");
        const keyImage = item.querySelector(".impact_image img");
  
        gsap.set(keyImage, { scale: 1 });
  
        if (index === 0) {
          gsap.set(item, {
            clipPath: "inset(0% 0% 0% 0%)",
          });
        } else {
          visualTl.fromTo(
            item, { clipPath: "inset(100% 0% 0% 0%)" },
            inAnimationVisual
          );
          visualTl.fromTo(
            keyImage, { scale: 1.15 }, { scale: 1, duration: 0.5, ease: 'none' },
            "<"
          );
        }
      });
    });
  }
  
  // swiper
  
  // Product slider
  let impactSwiper = document.querySelector("[swiper='impact']");
  
  if (impactSwiper) {
  
    let impactSwiperElement = impactSwiper.querySelector(".swiper");
  
    var swiper = new Swiper(impactSwiperElement, {
      speed: 450,
      slidesPerView: "auto",
      spaceBetween: 12,
      loop: false,
      enabled: true, // Swiper is enabled by default
      centeredSlides: false,
      mousewheel: { forceToAxis: true },
      on: {
        // Use 'afterInit' instead of 'init' to ensure Swiper is fully initialized
        afterInit: function (swiper) {
          // Set total slides count after init
          const totalSlides = swiper.slides.length;
          document.querySelector("[swiper-index='total']").innerText = totalSlides
            .toString().padStart(2, '0');
        },
        slideChange: function (swiper) {
          // Update current slide index on slide change
          const currentSlide = swiper.realIndex + 1;
          document.querySelector("[swiper-index='current']").innerText = currentSlide
            .toString().padStart(2, '0');
        }
      },
      breakpoints: {
        // Disable Swiper for screen sizes 767px and above
        767: {
          enabled: false,
          spaceBetween: 0,
        }
      }
    });
  
  }
  